import { Home } from '@material-ui/icons';
import HomeView from './home';
export default HomeView;